/* ============================================================
   COR STOREFRONT V2 — interactions
   - Filter rail (type / brand / price band)
   - Sort
   - Hero stage 3D drag rotation hint
   - Magnetic hover on product cards (gated)
   - Card reveal observer (delegates to data-cor-reveal CSS)
   - Bilingual count refresh on language toggle
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var root = document.querySelector('[data-cor-store]');
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarsePointer = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* ---------- helpers ---------- */
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }
  function unique(arr) {
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var v = (arr[i] || '').trim();
      if (!v || seen[v]) continue;
      seen[v] = 1;
      out.push(v);
    }
    return out.sort();
  }
  function isHebrew() {
    return document.documentElement.classList.contains('cor-lang-he');
  }

  /* ---------- collect product data ---------- */
  var cards = $$('[data-cor-card]');
  var grid  = root.querySelector('[data-cor-grid]');

  /* ---------- 1. populate filter rail from card data ---------- */
  function populateFilters() {
    var byType  = unique(cards.map(function (c) { return c.dataset.type;  }));
    var byBrand = unique(cards.map(function (c) { return c.dataset.brand; }));

    fillRail('type',  byType);
    fillRail('brand', byBrand);
  }
  function fillRail(key, values) {
    var list = root.querySelector('[data-cor-filter-list="' + key + '"]');
    if (!list) return;
    values.forEach(function (v) {
      var li = document.createElement('li');
      var b  = document.createElement('button');
      b.type = 'button';
      b.className = 'cor-sv-chip';
      b.setAttribute('data-cor-filter', key);
      b.setAttribute('data-value', v);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = v;
      li.appendChild(b);
      list.appendChild(li);
    });
  }
  populateFilters();

  /* ---------- 2. filter / sort state ---------- */
  var state = { type: '', brand: '', price: '', sort: 'price-asc' };
  var sortSelect   = root.querySelector('[data-cor-sort]');
  var resetBtn     = root.querySelector('[data-cor-reset]');
  var countEl      = root.querySelector('[data-cor-result-count]');
  var activeCount  = root.querySelector('[data-cor-active-count]');
  var rail         = root.querySelector('[data-cor-rail]');
  var railToggle   = root.querySelector('[data-cor-rail-toggle]');

  function inPriceBand(card) {
    if (!state.price) return true;
    var parts = state.price.split('-');
    var lo = Number(parts[0] || 0);
    var hi = Number(parts[1] || 1e9);
    var p  = Number(card.dataset.priceNum || 0);
    return p >= lo && p <= hi;
  }

  function applyFilters() {
    var visible = 0;
    var activeFilters = 0;

    ['type','brand','price'].forEach(function (k) {
      if (state[k]) activeFilters++;
    });

    cards.forEach(function (card) {
      var show =
        (!state.type  || card.dataset.type  === state.type)  &&
        (!state.brand || card.dataset.brand === state.brand) &&
        inPriceBand(card);
      card.hidden = !show;
      if (show) visible++;
    });

    if (grid) {
      cards.slice().sort(function (a, b) {
        if (state.sort === 'brand') {
          return (a.dataset.brand || '').localeCompare(b.dataset.brand || '') ||
                 (a.dataset.title || '').localeCompare(b.dataset.title || '');
        }
        var ap = Number(a.dataset.priceNum || 0);
        var bp = Number(b.dataset.priceNum || 0);
        return state.sort === 'price-desc' ? bp - ap : ap - bp;
      }).forEach(function (c) { grid.appendChild(c); });
    }

    refreshCount(visible);
    refreshChips();

    if (resetBtn) resetBtn.hidden = activeFilters === 0 && state.sort === 'price-asc';
    if (activeCount) {
      activeCount.hidden = activeFilters === 0;
      activeCount.textContent = String(activeFilters);
    }
  }

  function refreshCount(visible) {
    if (!countEl) return;
    var total = cards.length;
    var nounEn = countEl.getAttribute('data-cor-noun-en') || 'shells';
    var nounHe = countEl.getAttribute('data-cor-noun-he') || 'קסדות';

    var strong = countEl.querySelector('strong');
    var spans  = countEl.querySelectorAll('span');
    var em     = countEl.querySelector('em');

    if (strong) strong.textContent = String(visible);
    if (spans.length >= 2) spans[1].textContent = String(total);
    if (em) {
      em.setAttribute('data-cor-en', nounEn);
      em.setAttribute('data-cor-he', nounHe);
      em.textContent = isHebrew() ? nounHe : nounEn;
    }
  }

  function refreshChips() {
    $$('[data-cor-filter]').forEach(function (chip) {
      var key = chip.getAttribute('data-cor-filter');
      var val = chip.getAttribute('data-value') || '';
      var on  = state[key] === val;
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- 3. wire interactions ---------- */
  root.addEventListener('click', function (ev) {
    var chip = ev.target.closest('[data-cor-filter]');
    if (chip && root.contains(chip)) {
      var key = chip.getAttribute('data-cor-filter');
      var val = chip.getAttribute('data-value') || '';
      state[key] = val;
      applyFilters();
    }
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      applyFilters();
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      state.type = state.brand = state.price = '';
      state.sort = 'price-asc';
      if (sortSelect) sortSelect.value = 'price-asc';
      applyFilters();
    });
  }

  if (railToggle && rail) {
    if (!rail.id) rail.id = 'cor-sv-rail-mobile';
    railToggle.addEventListener('click', function () {
      var open = rail.classList.toggle('is-open');
      railToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- 4. card reveal observer (own, gentle stagger per row) ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function (c, i) {
      c.style.transitionDelay = (i % 4) * 60 + 'ms';
      io.observe(c);
    });

    /* observe hero/headline children for reveal-child */
    $$('[data-cor-reveal]').forEach(function (el) {
      var inner = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-revealed');
          var children = e.target.querySelectorAll('[data-cor-reveal-child]');
          var stagger  = parseInt(e.target.getAttribute('data-cor-reveal-stagger') || '80', 10);
          children.forEach(function (child, i) {
            setTimeout(function () { child.classList.add('is-revealed'); }, i * stagger);
          });
          inner.disconnect();
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
      inner.observe(el);
    });
  } else {
    cards.forEach(function (c) { c.classList.add('is-revealed'); });
    $$('[data-cor-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
      el.querySelectorAll('[data-cor-reveal-child]').forEach(function (c) { c.classList.add('is-revealed'); });
    });
  }

  /* ---------- 5. magnetic hover on cards (subtle) ---------- */
  function initMagnet() {
    if (reduceMotion || coarsePointer) return;
    cards.forEach(function (card) {
      var rect;
      var media = card.querySelector('.cor-sv-card__media');
      var render = card.querySelector('.cor-sv-card__render');
      function move(ev) {
        rect = card.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top  + rect.height / 2;
        var dx = (ev.clientX - cx) / rect.width;
        var dy = (ev.clientY - cy) / rect.height;
        if (render) {
          render.style.transform = 'translate3d(' + (dx * -10) + 'px,' + (dy * -10) + 'px,0) scale(1.04)';
        }
        if (media) {
          media.style.transform = 'perspective(900px) rotateX(' + (dy * -3) + 'deg) rotateY(' + (dx * 4) + 'deg)';
        }
      }
      function reset() {
        if (render) render.style.transform = '';
        if (media)  media.style.transform  = '';
      }
      card.addEventListener('pointermove', move, { passive: true });
      card.addEventListener('pointerleave', reset);
    });
  }
  initMagnet();

  /* ---------- 6. hero 3D drag-rotate hint (helmets only) ----------
     If cor-helmet-3d.js is loaded it self-initialises from
     [data-cor-helmet]. We only add a soft cursor hint here.
  ----------------------------------------------------------------- */
  var heroThree = root.querySelector('.cor-sv-hero__three');
  if (heroThree && !reduceMotion && !coarsePointer) {
    heroThree.style.cursor = 'grab';
    heroThree.addEventListener('pointerdown', function () { heroThree.style.cursor = 'grabbing'; });
    window.addEventListener('pointerup',   function () { heroThree.style.cursor = 'grab'; });
  }

  /* ---------- 7. RTL-aware scroll cue smooth scroll ---------- */
  var cue = root.querySelector('.cor-sv-scroll-cue');
  if (cue) {
    cue.addEventListener('click', function (ev) {
      ev.preventDefault();
      var target = document.getElementById('cor-sv-catalog');
      if (!target) return;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- 8. language change repaints i18n bits ---------- */
  document.addEventListener('shopify:section:load', function () {
    /* if section re-loaded in theme editor, re-run */
    applyFilters();
  });
  /* hook language toggle (corApplyLanguage exposed by theme.liquid) */
  var langPrev = isHebrew();
  setInterval(function () {
    var cur = isHebrew();
    if (cur !== langPrev) {
      langPrev = cur;
      var visible = cards.filter(function (c) { return !c.hidden; }).length;
      refreshCount(visible);
    }
  }, 600);

  /* ---------- initial apply ---------- */
  applyFilters();
})();
